define('app/dashboard/widgets/LineChartDashboardItemView',['require','./ReportDashboardItemView','app/app','app/visualizations/LineChart','hbs!./LineChartDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		APP = require('app/app'),
		LineChart = require('app/visualizations/LineChart');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-item-line-chart',
		template: require('hbs!./LineChartDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		regions: {
			chartContainer: '.line-chart-container'
		},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		onRender: function() {
			var self = this,
				report = this.options.model,
				dashboard,
				options = {
					model: self.model,
					height: 300,
					width: 300,
					showLegend: false,
					showSubchart: false,
					showTicks: false,
					fixToolTips: true,
					paddingRight: 5,
					paddingLeft: 5
				};

			if (APP && APP.dashboards && APP.dashboards.length > 0) {
				dashboard = APP.dashboards.find(function(d) {
					return d.id === report.get('dashboardId');
				});
			}

			if (dashboard && dashboard.get('layout') === 'MARKETING') {
				switch (report.get('name')) {
					case 'Request Volume':
						options.width = undefined;
						options.showTicks = true;
						options.paddingLeft = 100;
						options.paddingRight = 100;
						options.grid = {
							x: {
								show: true
							},
							y: {
								show: true
							}
						};
						options.axis = {
							x: {
								tick: {
									culling: {
										max: 30
									}
								}
							},
							y: {
								padding: {
									top: 200,
									bottom: 200
								}
							}
						};
						options.simpleDateFormat = true;
						break;
				}
			}

			if (report && report.consumableResults() && report.consumableResults().rows() && report.consumableResults().rows().length > 30) {
				// hide labels if there is too much data
				options.showTicks = false;
			}

			self.chartView = new LineChart(options);
			self.chartContainer.show(self.chartView);
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		onClose: function() {
			if (this.chartView) {
				this.chartView.close();
			}

			this.remove();
			this.unbind();
			this.model.unbind('change', this.modelChanged);
		}
	});
});

